export default __webpack_public_path__ + "navigation-examples-route-init-1200-042aed0f9da7b47a2987f482f233bda2.webp";